import VideoSelectionInputModal from './toolbar/videoSelectionInputModal';

const Modals = {
  VIDEO_SELECTION_INPUT: 'video-selection-input',
};

const ModalsMap = {
  [Modals.VIDEO_SELECTION_INPUT]: VideoSelectionInputModal,
};

export { Modals, ModalsMap };
